// @shared/api/analytics.ts
import type {
  KalamaTeaserSurface,
  RecordKalamaTeaserSeenDto,
  TrackUpgradeFunnelEventDto,
} from '../core/analytics';
import type { HttpClient } from './http';

export interface TrackAnalyticsBody {
  event: string;
  properties?: Record<string, unknown>;
}

export interface AnalyticsService {
  track(event: string, properties?: Record<string, unknown>): Promise<void>;
  trackUpgradeFunnel(body: TrackUpgradeFunnelEventDto): Promise<void>;
  recordKalamaTeaserSeen(surface: KalamaTeaserSurface): Promise<void>;
}

export function createAnalyticsService(
  httpClient: HttpClient,
  baseUrl: string,
): AnalyticsService {
  const BASE_URL = `${baseUrl}/analytics`;

  return {
    async track(event, properties) {
      return httpClient<void>(`${BASE_URL}/track`, 'post', {
        body: { event, properties },
      });
    },

    async trackUpgradeFunnel(body) {
      return httpClient<void>(`${BASE_URL}/upgrade-funnel`, 'post', { body });
    },

    async recordKalamaTeaserSeen(surface) {
      const body: RecordKalamaTeaserSeenDto = { surface };
      return httpClient<void>(`${BASE_URL}/kalama-teaser-seen`, 'post', {
        body,
      });
    },
  };
}
